module.exports = __webpack_public_path__ + "static/media/Logo-p10.3bd841da.png";